import React, { useEffect } from 'react';
import { Document, Page, StyleSheet, View, Text, Image, Font, Link } from '@react-pdf/renderer';
import ProximaNovaRegular from 'Assets/font/proximanova_regular.ttf';
import ProximaNovaBold from 'Assets/font/ProximaNova-Bold.ttf';
import ProximaNovaThin from 'Assets/font/FontsFree-Net-Proxima-Nova-Thin.ttf';
import ProximaNovalight from 'Assets/font/proximanova_light.ttf';
import Proxima_Nova_Semibold from 'Assets/font/fonnts.com-Proxima_Nova_Semibold.ttf';
import logo from "Assets/images/logo.png";
import peerRef from "Assets/images/peerref.png"
import ProximaNovaRegularItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Reg-It.otf';
import ProximaNovaThinItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Thin-It.otf';
import ProximaNovaBoldItalic from 'Assets/font/FontsFree-Net-ProximaNovaBoldItalic.ttf';
import ProximaNovaSemiBoldItalic from 'Assets/font/FontsFree-Net-ProximaNovaSemiboldItalic.ttf';
import ProximaNovaLightItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Light-It.otf';
import { ClientDetailsPdf } from '../../../../../components/Reports/ReportPdfComponents/ClientDetails';
import PDFHtmlRenderer from '../../../../../components/Reports/ReportPdfComponents/PDFHtmlRenderer';
import { PdfFooter } from 'components/PdfFooter';
import { PdfPeerFooterV2 } from './PeerPdfFooterV2';
import { extractUploadFileName } from 'helpers/common';
// import PDFHtmlRenderer from "./Components/PDFHtmlRenderer";

Font.register({
    family: 'Proxima Nova',
    fonts: [
        { src: ProximaNovaThin, fontWeight: 100 },         // thin
        { src: ProximaNovalight, fontWeight: 300 },        // light
        { src: ProximaNovaRegular, fontWeight: 400 },      // normal
        { src: Proxima_Nova_Semibold, fontWeight: 600 },   // semibold
        { src: ProximaNovaBold, fontWeight: 700 },         // bold
        { src: ProximaNovaThinItalic, fontWeight: 'thin', fontStyle: 'italic' },
        { src: ProximaNovaLightItalic, fontWeight: 'light', fontStyle: 'italic' },
        { src: ProximaNovaRegularItalic, fontWeight: 'normal', fontStyle: 'italic' },
        { src: ProximaNovaSemiBoldItalic, fontWeight: 'semibold', fontStyle: 'italic' },
        { src: ProximaNovaBoldItalic, fontWeight: 'bold', fontStyle: 'italic' },
    ],
});


const styles = StyleSheet.create({
    page: {
        color: "#000",
        padding: 20,
        backgroundColor: '#ffffff',
        fontFamily: 'Proxima Nova',
        paddingBottom: 100,
    },
    container: {
        padding: '0 40px 0 40px',
    },
    pageNumber: {
        textAlign: "right"
        // position: "absolute",
        // right: "10%"
    },
    fontBold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'bold'
    },
    fontSemibold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'semibold'
    },
    fontLight: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'light'
    },
    headerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "flex-end",
        marginBottom: 20,
        padding: '0 40px 0 0',
    },
    logo: {
        width: 127,
    },
    headerTitle: {
        fontSize: 9,
        textAlign: 'center',
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 16,
        textAlign: 'center',
        marginTop: 3,
        color: "#93278F"
    },
    border: {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        marginBottom: "8px"
    },
    mainHeading: {
        fontSize: 10,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
    },
    mainSubHeading: {
        fontSize: 8,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
        letterSpacing: "1px",
        textTransform: "uppercase"
    },
    subHeading: {
        fontSize: 7,
        fontWeight: 'semibold',
    },
    para: {
        fontSize: 8,
        fontWeight: 'normal'
    },
    flex: {
        display: "flex",
        flexDirection: "row"
    },
    halfCol: {
        width: '50%',
    },
    mainSubHeadingWithOutSpacing: {
        fontSize: 8,
        fontWeight: 'thin',
        fontFamily: 'Proxima Nova',
        textTransform: "uppercase",
        color: "#000"
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        fontSize: 10,
        // color: 'grey',
        padding: '0px 60px 0px 60px',
        // marginTop: "10px",
        marginBottom: "-10px",
    },
    link: {
        fontSize: 7,
        color: "#000",
        fontFamily: 'Proxima Nova',
        fontWeight: 'light',
        // borderBottom: "1px solid #333"
    }
    ,
    twoColRowMain: {
        flexDirection: "row",
        gap: 20,
        marginTop: 10,
        justifyContent: "space-between",
        alignItems: "flex-end"
    },
    twoColSectionOne: {
        flexDirection: "row",
        gap: 20,
        marginTop: 5,
    },
    twoColSectionTwo: {
        flexDirection: "row",
        gap: 20,
        marginTop: 20,
    },

    leftImageCol: {
        width: "40%"
    },

    rightTextCol: {
        width: "60%"
    },

    volunteerLeftCol: {
        width: "40%"
    },

    volunteerRightCol: {
        width: "60%"
    },

    programImage: {
        width: "100%",
        height: 140,
        objectFit: "cover"
    },

    infoBlock: {
        marginBottom: 10
    },

    infoLabel: {
        fontSize: 7,
        textTransform: "uppercase",
        fontWeight: "semibold"
    },
    infoValues: {
        fontSize: 16,
        marginTop: 2,
        fontWeight: 300
    },
    infoValue: {
        fontSize: 9,
        marginTop: 2
    }

});

const PeerPdfViewV2 = ({ data }) => {
    const reportQuestions = data?.reportQuestions;
    const reportAnswers = data?.reportAnswers;
    const reportRecommendations = data?.recommendation;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View
                    style={styles.pageNumber}
                    render={({ pageNumber, totalPages }) => (
                        <Text style={{ ...styles.para }}>Page {pageNumber}/{totalPages}</Text>
                    )}
                    fixed
                ></View>
                <View style={styles.headerRow}>
                    <View>
                        <Image style={styles.logo} src={logo} />
                    </View>
                    <View style={{ alignItems: "flex-end" }}>
                        {/* <Text style={styles.subtitle}>{data?.therapist?.therapist_discipline?.name}</Text> */}
                        {/* <Text style={styles.subtitle}>Volunteer Reference Letter</Text> */}
                        {/* <Text style={styles.subtitle}>Intake Session Report</Text> */}
                    </View>
                </View>

                <View style={styles.container}>
                    <View>
                        <View style={{ ...styles.border, ...styles.twoColRowMain }}>
                            <Text style={{ ...styles.mainHeading }}>ABOUT THE CHATTER PROGRAM</Text>
                            <Text style={styles.subtitle}>Volunteer Reference Letter</Text>
                        </View>
                        <View style={styles.twoColSectionOne}>

                            {/* LEFT IMAGE */}
                            <View style={styles.leftImageCol}>
                                <Image
                                    style={styles.programImage}
                                    src={peerRef} // replace with real image
                                />
                            </View>

                            {/* RIGHT TEXT */}
                            <View style={styles.rightTextCol}>
                                {/* <Text style={{ ...styles.para, fontSize: 9 }}>
                                    {data?.about_chatter?.text}
                                </Text> */}
                                <PDFHtmlRenderer
                                    style={{ ...styles?.para, fontSize: 9 }}
                                    data={data?.about_chatter?.text}
                                />

                                <View>
                                    {
                                        data?.about_chatter?.attachments?.length > 0 &&
                                        <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                    }

                                    {Array.isArray(data?.about_chatter?.attachments) &&
                                        data.about_chatter.attachments.map((item, index) => {
                                            const url = item?.attachment_key;
                                            if (!url) return null;
                                            return (
                                                <Link key={index} src={url} style={styles.link}>
                                                    {extractUploadFileName(item?.attachment_name)}
                                                </Link>
                                            );
                                        })
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={styles.container}>
                    <View style={styles.twoColSectionTwo}>

                        {/* LEFT VOLUNTEER INFO */}
                        <View style={styles.volunteerLeftCol}>

                            <View style={styles.border}>
                                <Text style={styles.mainHeading}>VOLUNTEER INFORMATION</Text>
                            </View>

                            <View style={styles.infoBlock}>
                                <Text style={styles.infoLabel}>FIRST NAME</Text>
                                <Text style={styles.infoValues}>{data?.firstname}</Text>
                            </View>

                            <View style={styles.infoBlock}>
                                <Text style={styles.infoLabel}>LAST NAME</Text>
                                <Text style={styles.infoValues}>{data?.lastname}</Text>
                            </View>

                            <View style={styles.infoBlock}>
                                <Text style={styles.infoLabel}>START DATE</Text>
                                <Text style={styles.infoValue}>{data?.start_date}</Text>
                            </View>

                            <View style={styles.infoBlock}>
                                <Text style={styles.infoLabel}>TOTAL WEEKS</Text>
                                <Text style={styles.infoValue}>
                                    {data?.weeks_volunteered ? `${data?.weeks_volunteered} Weeks` : "-"}
                                </Text>
                            </View>

                            <View style={styles.infoBlock}>
                                <Text style={styles.infoLabel}>CONFIRMATION OF HOURS</Text>
                                <Text style={styles.infoValue}>
                                    {data?.hours_volunteered ? `${data?.hours_volunteered} hours` : "-"}
                                </Text>
                            </View>

                        </View>

                        {/* RIGHT ABOUT VOLUNTEER */}
                        <View style={styles.volunteerRightCol}>

                            <View style={styles.border}>
                                <Text style={styles.mainHeading}>ABOUT THE VOLUNTEER</Text>
                            </View>


                            <PDFHtmlRenderer
                                style={{ ...styles?.para, fontSize: 9 }}
                                data={data?.about?.text}
                            />
                            <View>
                                {
                                    data?.about?.attachments?.length > 0 &&
                                    <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                }
                                {Array.isArray(data?.about?.attachments) &&
                                    data.about.attachments.map((item, index) => {
                                        const url = item?.attachment_key;
                                        if (!url) return null;

                                        return (
                                            <Link key={index} src={url} style={styles.link}>
                                                {extractUploadFileName(item?.attachment_name)}
                                            </Link>
                                        );
                                    })
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <PdfPeerFooterV2 data={data} />
            </Page>
        </Document>
    )
};

export default PeerPdfViewV2;